// This function allow to reference async chunks
__webpack_require__.k = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"175":"pixi","252":"KramerStoreLocator"}[chunkId] || chunkId) + "." + {"252":"381b391f68e9cc385c54"}[chunkId] + ".css";
};